import { Group, Stack, Title } from '@mantine/core';
import { TagWithDelete } from '@pages/Asset/components/Sidebar/components/Tags/TagWithDelete';
import { fontsizesNum } from '@styles/fonts/fontsizes/fontsizes.styles';
import { TagCategoryProps } from './TagDialog.types';

export function TagCategoryList<T extends unknown[]>(
  props: TagCategoryProps<T>,
) {
  const {
    tags,
    categoryName,
    deleteHandler = () => () => {},
    deleteHandlerArgs = [] as unknown as T,
    calcTagProps = () => {},
  } = props;

  return (
    <Stack spacing={fontsizesNum.sm}>
      <Title order={6} size={12} weight={400} color="#696F8C">
        {categoryName}
      </Title>
      <Group spacing={8}>
        {tags.map(each => {
          return (
            <TagWithDelete
              id={each.id}
              key={each.id}
              color={each.color}
              name={each.tagName}
              deleted={false}
              showDelete={false}
              className="rm-m rm-cur"
              onDeleteIconClick={deleteHandler(each, ...deleteHandlerArgs)}
              {...calcTagProps(each)}
            />
          );
        })}
      </Group>
    </Stack>
  );
}
